const state = {
  videos: [],
}

const mutations = {
  RESET_VIDEOS: function (state) {
    state.videos = [];
  },
  ADD_VIDEO: function (state, video) {
    if (state.videos.findIndex(v => {
      return v.id === video.id
    }) === -1) {
      state.videos.push(video);
    }
  }
}

const actions = {

  initializeVideos({ commit, rootState }) {

    return new Promise(resolve => {
      let temp = [];
      let promiseArray = rootState.Categories.categories.map(cat => {
        return Promise.all(cat.videos.map(v => {
          return rootState.Database.db
            .collection("videos")
            .doc(v)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                let data = doc.data();
                data["id"] = doc.id;
                commit('ADD_VIDEO', data);
              }
            });
        }));
      })

      Promise.all(promiseArray).then(() => {
        resolve(true);
      })

    })
  }
}

const getters = {
  getVideos(state) {
    if (state.videos.length > 0) {
      return state.videos.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }
    else {
      return []
    }

  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Videos.js